export default "__VITE_ASSET__Bq0Tv1_M__"